const breadcrumbsMessages = {
  youAreHere: ['breadcrumbsMessages>>youAreHere', 'Jesteś tutaj'],
  myProfile: ['breadcrumbsMessages>>myProfile', 'Profil pacjenta'],
  settings: ['breadcrumbsMessages>>settings', 'Ustawienia'],
  help: ['breadcrumbsMessages>>help', 'Pomoc'],
  services: ['breadcrumbsMessages>>services', 'Usługi'],
};

export default breadcrumbsMessages;
